// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'

// Parts
/**
* Data serialization types available
* @name DataTypes
* @type {Object}
* @property {Mixin} ObjectDataType - Serializes form in simple Object
* @property {Mixin} RawDataType - Serializes form in a string
*/
const {
  ObjectDataType: dataType,
  RawDataType,
} = DataTypes
/**
* Submit actions types available
* @name SubmitTypes
* @type {Object}
* @property {Mixin} AjaxSubmit - Submit the serialize data with ajax to the server
* @property {Mixin} ReturnSubmit - Returns the serialize data
* @property {Mixin} CheckOutSubmit - Runs the check-out functionality throght the store
*/
const {
  AjaxSubmit: submitType,
  ReturnSubmit,
  CheckOutSubmit
} = SubmitTypes
/**
* Error handling types available
* @name ErrorTypes
* @type {Object}
* @property {Mixin} DummyError - Stringify the error and uses it as message
* @property {Mixin} CheckOutError - Handles check-out errors throught the store
* @property {Mixin} AccountError - Handles account service errors
* @property {Mixin} ProblemDetailsError - Handles ProblemDetails implementation
*/
const {
  DummyError,
  CheckOutError,
  ProblemDetailsError: errorHandling,
} = ErrorTypes

// Options
/**
* Form Options
* @type {Object}
* @property {String} name - Name used for tracking
* @property {DataTypes} dataType - Serialization to be used
* @property {SubmitTypes} submitType - Submit action to be used
* @property {ErrorTypes} errorHandling - Error handling to be used
* @property {Boolean} submitOnChange - Submit the form on every input change
* @property {Boolean} skipValidation - Skip validation on form submit
* @property {Object} tracking - Tracking configuration
* @property {Boolean} tracking.view - true to track form view event
* @property {Boolean} tracking.validation - true to track form validation event
* @property {Boolean} tracking.submit - true to track form submit event or
* pass an object to extend the tracked DataLayer
* @property {Boolean} tracking.error - true to track form server error event
*/
const options = {
  name: 'fmo:request-booking',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: false,
    submit: { events: { requestbooking: true } },
    error: false
  }
}

// Component
export default {
  name: 'request-booking-form',
  mixins: [
    /**
    * Base mixin for building forms
    * @type {Function}
    * @param {Object} options - Configuration options, see bellow
    */
    Base(options)
  ],
  data: () => ({
    completed: false,
    grecaptchaToken: '',
    grecaptchaReady: false
  }),
  computed:  {
    innerScope() {
      return {
        completed:this.completed,
        resetForm:this.resetForm,
        grecaptchaCallback: this.grecaptchaCallback,
        grecaptchaExecute: this.grecaptchaExecute,
        grecaptchaToken: this.grecaptchaToken,
        grecaptchaReady: this.grecaptchaReady,
        grecaptchaReadyCallback: this.grecaptchaReadyCallback
      }

    }
  },
  methods: {
    /**
    * Transforms the data before passing it
    * to the submit action.
    * Remove if not needed.
    * @param {Object|String} data
    */
    async transformData(data) {
      this.$logger.debug('transformData: ', data)
      return {
        ...data,
        grecaptchaCallback: this.grecaptchaCallback,
        grecaptchaExecute: this.grecaptchaExecute,
        grecaptchaToken: this.grecaptchaToken,
        grecaptchaReady: this.grecaptchaReady,
        grecaptchaReadyCallback: this.grecaptchaReadyCallback
      }
    },
    /**
    * Transforms the response before passing it
    * to the final action.
    * Remove if not needed.
    * @param {Object|String} response
    * @param {Object|String} data
    */
    async transformResponse(response, data) {
      this.$logger.debug('transformResponse: ', response)
      if (response.succeeded) {
        this.completed = true
      }
      return response
    },
    resetForm() {
      document.getElementById("request-booking").reset();
      this.completed = false
    },
    grecaptchaCallback(token) {
      this.grecaptchaToken = token
      this.$nextTick(() => {
        this.form.submit()
      });
    },
    grecaptchaReadyCallback() {
      this.grecaptchaReady = true
    },
    grecaptchaExecute() {
      this.$root.$emit('grecaptcha-execute')
    }
  }
}
